import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../contexts/auth";
import { Roles } from "../enums/Roles";

type Props = {
  checkAdmin?: boolean;
};

export default function RouteGuard({ checkAdmin }: Props) {
  const { token, loggedUser } = useAuth();
  if (!token || (checkAdmin && loggedUser && loggedUser.role > Roles.Host)) {
    return <Navigate to="/login" />;
  }
  return <Outlet />;
}
